<template>
  <v-col v-if="document.id" cols="12" style="padding-right: 0">
    <v-card :href="`/storage/documents/${document.file_path}`" target="_blank">
      <v-card-text><h4>{{ document.title }}</h4></v-card-text>
      <v-card-text>
        Érvényesség kezdete: <b>{{ formatDate(document.effective_date) }}</b>
        Érvényesség vége:<b>{{ formatDate(effective_date) }}</b>
      </v-card-text>
      <v-card-text>{{ document.file_path }}</v-card-text>
    </v-card>
    <DocumentVariants
      v-if="document[relation]"
      :document="document[relation]"
      :effective_date="document.effective_date"
      :relation="relation"
    />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Datepicker from '../../Pickers/Datepicker'
import YearPicker from '../../Pickers/YearPicker'
import Toolbar from '../../Modals/Toolbar'
import _ from 'lodash'

export default {
  name: 'DocumentVariants',
  props: {
    document: {
      required: true,
    },
    effective_date: {
      required: false,
      default: 'Jelenleg hatályos',
    },
    relation:{
      required:true,
      default:'parent'
    }
  },
  data () {
    return {}
  },
  methods: {
    formatDate (date) {
      let f = date.substr(0, date.indexOf('T'))
      return (Date.parse(f)) ? f : date
    },
  },
}
</script>
